const zh_CN = {
  platform: '佳沛电商数据分析平台',
  Forget_Password: '忘记密码',
  Log_In: '登录',
  Welcome: '欢迎,',
  Confirm: '确认',
  Product: '果子',
  View_original: '查看原帖',
  Trendpopularity_Fruit: '果子评论热度趋势',
  FruitCommentsShare: '果子评论热度占比',
  FruitComments_MOM: '果子评论热度环比',
  FruitComments_YOY: '果子评论热度同比',

  Channelcomment_popularity: '渠道评论热度占比',
  Channelcomments_emotions: '渠道评论情感占比',
  TrendFruit_EmotionalHeat: '果子情感趋势',
  Trendproportion_emotions: '果子情感占比',
  Attributenegative_emotion: '属性负向情感',
  Attributepositive_emotion: '属性正向情感',
  Trendattributeemotion_proportion: '属性情感占比趋势',
  ComparisonAttributeEmotion_Proportion: '属性情感占比对比',
  WordCloud: '词云',
  Data_Definition: '数据说明',
  WordCloudRanking: '词云排行榜',
  dataInfo:
    '本系统自2024年7月1日起正式启动数据抓取，2024年7月前为回溯数据，可能存在缺失，建议仅作参考。同比图中若包含回溯期间“上期”数据，建议手动取消勾选，以确保分析准确性。',
}
export default zh_CN
